import React, { Component }  from 'react'
import { Link } from 'react-router'

export default class Hamburger extends Component{
	render(){
		return(
			<Link
				to={`/manager/home`}
				style={{
					textDecoration: 'none'
				  , backgroundColor: "rgb(41, 48, 56)"
				  , width: "55px"
				  , height: "60px"
				  , textAlign: "center"
				  , paddingTop: "18px"
				  , borderBottom: "1px solid rgb(225, 227, 226)"
				  , display: "inline-block"
				}}
			  >
				<img
					src={'/' + process.env.REACT_APP_NAME + "/static/img/hamburger.png"}
					style={{
						height: "15px"
					  , width: "24px"
					  , verticalAlign: 'middle'
					  , cursor: 'pointer'

					}}
				/>
			</Link>
		)}
}



// WEBPACK FOOTER //
// ./src/components/Hamburger.js